"use strict";

const root = document.documentElement;

const getScrollBarWidth = {
  init: function () {
    return window.innerWidth - document.documentElement.clientWidth;
  }
};

function initLazyloadItem() {
  if (typeof window.lazySizes === "object" && typeof window.lazySizes.init === "function") {
    window.lazySizes.init();
  }
}

const options_collection = {
  collectionsLoadMore: ".collections-load-more",
  rangeSlider: ".price-range .range-slider",
  rangeSliderMin: ".range-slider-min",
  rangeSliderMax: ".range-slider-max",
  minPriceRange: ".min-price-range",
  maxPriceRange: ".max-price-range",
  collectionSidebar: "#CollectionSidebar",
  collectionFilterBlocks: ".filter-blocks",
  productgridcontainer: "#productgridcontainer",
  collectionFiltersForm: "#CollectionFiltersForm",
  section: ".sec__collection-main",
};

class BtnFilter extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onOpen.bind(this), false);
  }
  onOpen(e) {
    if (e) e.preventDefault();
    const sidebar = document.getElementById("CollectionSidebar");
    const drawer = document.querySelector("[data-filter-drawer]");
    const overlay = document.querySelector("[data-filter-overlay]");

    if (drawer && overlay) {
      drawer.classList.add("is-open");
      overlay.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      document.body.classList.add("filter-drawer-locked");
      return;
    }

    if (sidebar) {
      if (!sidebar.classList.contains("open")) {
        sidebar.classList.add("open");
        document.documentElement.classList.add("open-drawer", "open-sidebar");
        root.style.setProperty("padding-right", getScrollBarWidth.init() + "px");
        this.classList.add("open");
      } else {
        sidebar.classList.remove("open");
        document.documentElement.classList.remove("open-drawer", "open-sidebar");
        root.style.removeProperty("padding-right");
        this.classList.remove("open");
      }
    }
  }
}
if (!customElements.get("btn-filter")) {
  customElements.define("btn-filter", BtnFilter);
}

class CloseFilter extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onClose.bind(this), false);
  }
  onClose() {
    const sidebar = document.getElementById("CollectionSidebar");
    const drawer = document.querySelector("[data-filter-drawer]");
    const overlay = document.querySelector("[data-filter-overlay]");

    if (drawer && overlay) {
      drawer.classList.remove("is-open");
      overlay.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      document.body.classList.remove("filter-drawer-locked");
    }

    if (sidebar) {
      sidebar.classList.remove("open");
      document.documentElement.classList.remove("open-drawer", "open-sidebar");
    }

    document.querySelectorAll(".btn-filter").forEach(btn => btn.classList.remove("open"));
    root.style.removeProperty("padding-right");
  }
}
if (!customElements.get("close-filter")) {
  customElements.define("close-filter", CloseFilter);
}

class FacetApplyCanvas extends CloseFilter {
  constructor() {
    super();
    this.addEventListener("click", this.onClose.bind(this), false);
  }
}
if (!customElements.get("facet-apply-canvas")) {
  customElements.define("facet-apply-canvas", FacetApplyCanvas);
}

class GridMode extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.gridMode.bind(this), false);
  }
  gridMode() {
    const view_mode = this.getAttribute("data-grid-mode");
    if (this.classList.contains("active")) return;
    if (view_mode == 1) return;
    for (var item of document.querySelectorAll("grid-mode")) {
      item.classList.remove("active");
    }
    const container_switch = document.querySelector(
      ".container-products-switch"
    );
    if (!container_switch) return;
    this.classList.add("active");
    const data_view_mode = container_switch.getAttribute("data-view-mode");
    container_switch.classList.remove("grid-columns-" + data_view_mode);
    container_switch.setAttribute("data-view-mode", view_mode);
    container_switch.classList.add("grid-columns-" + view_mode);
  }
}
if (!customElements.get("grid-mode")) {
  customElements.define("grid-mode", GridMode);
}

class ViewMode extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.viewMode.bind(this), false);
  }
  viewMode() {
    const view_mode = this.getAttribute("data-view");
    if (this.classList.contains("actived")) return;
    var queryString = window.location.search;
    queryString = eventCollectionShopify.removeParam("view", queryString);
    if (view_mode == "list") {
      var searchParams = queryString.replace("?", "") + "&view=list";
    } else {
      var searchParams = queryString.replace("?", "") + "&view=grid";
    }
    const url = eventCollectionShopify.renderUrl(searchParams);
    eventCollectionShopify.renderSectionFilter(url, searchParams);
  }
}
if (!customElements.get("view-mode")) {
  customElements.define("view-mode", ViewMode);
}

class FilterItem extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.filterItem.bind(this), false);
  }
  filterItem() {
    if (this.querySelector(".tooltip")) {
      this.querySelector(".tooltip").classList.toggle("current-filter");
    } else {
      if (this.closest("li")) {
        this.closest("li").classList.toggle("current-filter");
      }
    }
    const url = this.getAttribute("data-href");
    if (url) {
      eventCollectionShopify.renderSectionFilter(url);
    }
  }
}
if (!customElements.get("filter-item")) {
  customElements.define("filter-item", FilterItem);
}

class FacetClearAll extends CloseFilter {
  constructor() {
    super();
    this.addEventListener("click", this.filterItem.bind(this), false);
  }
  filterItem() {
    const url = this.getAttribute("data-href");
    if (url) {
      eventCollectionShopify.renderSectionFilter(url);
    }
    this.onClose();
  }
}
if (!customElements.get("facet-clear-all")) {
  customElements.define("facet-clear-all", FacetClearAll);
}

class FilterSort extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.filterSort.bind(this), false);
  }
  filterSort() {
    const value = this.getAttribute("value");
    let queryString = window.location.search;
    queryString = eventCollectionShopify.removeParam("sort_by", queryString);
    const searchParams = queryString.replace("?", "") + "&sort_by=" + value;
    const url = eventCollectionShopify.renderUrl(searchParams);
    eventCollectionShopify.renderSectionFilter(url, searchParams);
  }
}
if (!customElements.get("filter-sort")) {
  customElements.define("filter-sort", FilterSort);
}

class SelectSorter extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.activeFilterSort.bind(this), false);
  }
  activeFilterSort() {
    const customSelect = this.closest(".select-custom");
    if (customSelect) {
      customSelect.classList.toggle("active");
    }
  }
}
if (!customElements.get("select-sorter")) {
  customElements.define("select-sorter", SelectSorter);
}

var eventCollectionShopify = (function () {
  return {
    init: function () {
      this.ionRangeSlider();
      let windowWidth = window.innerWidth;
      if (windowWidth <= 1024) {
        const horizontal = document.querySelector(".horizontal-filter");
        if (horizontal) {
          const collapsible = document.querySelectorAll("collapsible-block");
          collapsible.forEach((e) => {
            e.classList.add("active");
          });
        }
      }
    },

    ionRangeSlider: function () {
      const price_range = document.querySelector(".price-range");
      const maxRange = document.querySelector(options_collection.rangeSliderMax);
      const minRange = document.querySelector(options_collection.rangeSliderMin);
      const minPrice = document.querySelector(".min-price-range");
      const maxPrice = document.querySelector(".max-price-range");
      if (!price_range || !minRange || !maxRange || !minPrice || !maxPrice) return;

      let minPriceRange = 0;
      let maxPriceRange = 0;

      const handleMinChange = (event) => {
        event.preventDefault();
        const target = event.currentTarget;
        target.value = target.value.replace(/,/g, "");
        if (Number(minRange.min) + Number(target.value) >= 0) {
          if (Number(target.value) > Number(maxRange.max)) {
            minPrice.value = Number(maxRange.max);
          } else {
            minPrice.value = Number(target.value);
          }
        } else {
          minPrice.value = Number(minRange.min);
        }
        const form = document.querySelector(options_collection.collectionFiltersForm);
        if (!form) return;
        const formData = new FormData(form);
        const params = new URLSearchParams(formData).toString();
        const nameMin = minPrice.getAttribute("name");
        const nameMax = maxPrice.getAttribute("name");
        let queryString = window.location.search;
        queryString = this.removeParam(nameMin, queryString);
        queryString = this.removeParam(nameMax, queryString);
        const searchParams = queryString.replace("?", "") + "&" + params;
        const url = this.renderUrl(searchParams);
        this.renderSectionFilter(url, searchParams);
      };

      const handleMaxChange = (event) => {
        event.preventDefault();
        const target = event.currentTarget;
        target.value = target.value.replace(/,/g, "");
        if (Number(maxRange.max) - Number(target.value) >= 0) {
          maxPrice.value = Number(target.value);
        } else {
          maxPrice.value = Number(maxRange.max);
        }
        const form = document.querySelector(options_collection.collectionFiltersForm);
        if (!form) return;
        const formData = new FormData(form);
        const params = new URLSearchParams(formData).toString();
        const nameMin = minPrice.getAttribute("name");
        const nameMax = maxPrice.getAttribute("name");
        let queryString = window.location.search;
        queryString = this.removeParam(nameMin, queryString);
        queryString = this.removeParam(nameMax, queryString);
        const searchParams = queryString.replace("?", "") + "&" + params;
        const url = this.renderUrl(searchParams);
        this.renderSectionFilter(url, searchParams);
      };

      minPrice.addEventListener("change", handleMinChange, false);
      maxPrice.addEventListener("change", handleMaxChange, false);

      minRange.addEventListener("input", (event) => {
        event.preventDefault();
        const target = event.currentTarget;
        if (Number(maxRange.value) - Number(target.value) >= 1) {
          minPrice.value = Number(target.value);
          minPriceRange = Number(target.value) * 100;
        } else {
          target.value = Number(maxRange.value) - 1;
          minPriceRange = (Number(maxRange.value) - 1) * 100;
        }
        const moneyFormat = window.cartStrings?.money_format || "Rs. {{amount}}";
        const price_format = window.Shopify?.formatMoney
          ? window.Shopify.formatMoney(minPriceRange, moneyFormat)
          : minPrice.value;
        const minLabel = document.querySelector(".price-lable .min");
        if (minLabel) minLabel.innerHTML = price_format;
        target.closest(".price-range")?.style.setProperty(
          "--range-from",
          (minRange.value / Number(target.getAttribute("max") || 100)) * 100 + "%"
        );
      }, false);

      maxRange.addEventListener("input", (event) => {
        event.preventDefault();
        const target = event.currentTarget;
        if (target.value - minRange.value >= 1) {
          maxPrice.value = target.value;
          maxPriceRange = Number(target.value) * 100;
        } else {
          target.value = Number(minRange.value) + Number(1);
          maxPriceRange = (Number(minRange.value) + Number(1)) * 100;
        }
        const moneyFormat = window.cartStrings?.money_format || "Rs. {{amount}}";
        const price_format = window.Shopify?.formatMoney
          ? window.Shopify.formatMoney(maxPriceRange, moneyFormat)
          : maxPrice.value;
        const maxLabel = document.querySelector(".price-lable .max");
        if (maxLabel) maxLabel.innerHTML = price_format;
        target.closest(".price-range")?.style.setProperty(
          "--range-to",
          (maxRange.value / Number(target.getAttribute("max") || 100)) * 100 + "%"
        );
      }, false);
    },

    removeParam: function (key, sourceURL) {
      if (!sourceURL) return "";
      var rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString = sourceURL.indexOf("?") !== -1 ? sourceURL.split("?")[1] : "";
      if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split("=")[0];
          if (param === key) {
            params_arr.splice(i, 1);
          }
        }
        if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
      }
      return rtn;
    },

    renderUrl: function (searchParams) {
      const sectionEl = document.querySelector(options_collection.section);
      const sectionId = sectionEl?.dataset?.sectionId || "main-collection-product";
      const cleanParams = (searchParams || "").replace(/^\?/, "").replace(/^&+/, "");
      return `${window.location.pathname}?section_id=${sectionId}&${cleanParams}`;
    },

    renderSectionFilter: function (url, searchParams) {
      this.toggleLoading(document.body, true);
      const fetchUrl = url.includes("section_id=") ? url : this.renderUrl(searchParams || url.split("?")[1] || "");

      fetch(fetchUrl)
        .then((response) => {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then((responseText) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(responseText, "text/html");

          // 1. Update Product Grid
          const newGrid = doc.querySelector(options_collection.productgridcontainer) || doc.querySelector("#product-grid");
          const curGrid = document.querySelector(options_collection.productgridcontainer);
          if (newGrid && curGrid) {
            curGrid.innerHTML = newGrid.innerHTML;
          }

          // 2. Update Filter Blocks / Drawer Form
          const newDrawerBody = doc.querySelector(".filter-drawer__body") || doc.querySelector("#FacetFiltersForm");
          const curDrawerBody = document.querySelector(".filter-drawer__body") || document.querySelector("#FacetFiltersForm");
          if (newDrawerBody && curDrawerBody) {
            curDrawerBody.innerHTML = newDrawerBody.innerHTML;
          }

          const newSidebar = doc.querySelector(options_collection.collectionFilterBlocks);
          const curSidebar = document.querySelector(options_collection.collectionFilterBlocks);
          if (newSidebar && curSidebar) {
            curSidebar.innerHTML = newSidebar.innerHTML;
          }

          // 3. Update count in toolbar
          const newCount = doc.querySelector(".collection-count") || doc.querySelector(".filter-drawer__count");
          const curCount = document.querySelector(".collection-count");
          if (newCount && curCount) {
            curCount.innerHTML = newCount.innerHTML;
          }

          document.documentElement.classList.remove("hside_opened");
          this.toggleLoading(document.body, false);
        })
        .catch((error) => {
          console.error("[Collection Filter Error]", error);
          this.toggleLoading(document.body, false);
        })
        .finally(() => {
          initLazyloadItem();
          eventCollectionShopify.ionRangeSlider();
        });

      this.updateUrl(url, searchParams);
    },

    toggleLoading: function (event, loading) {
      if (!event) return;
      if (loading) {
        event.classList.add("start", "loading");
      } else {
        event.classList.add("finish");
        setTimeout(function () {
          event.classList.remove("start", "loading", "finish");
        }, 500);
      }
    },

    updateUrl: function (url, searchParams = false) {
      if (searchParams) {
        const urlUpdate = `${window.location.pathname}?${searchParams.replace(/section_id=[^&]*&?/, "").replace(/^&+/, "")}`;
        window.history.pushState({ url: urlUpdate }, "", urlUpdate);
      } else if (url) {
        const cleanUrl = url.replace(/section_id=[^&]*&?/, "").replace(/\?$/, "");
        window.history.pushState({ url: cleanUrl }, "", cleanUrl);
      }
    },
  };
})();

document.addEventListener("DOMContentLoaded", () => {
  eventCollectionShopify.init();
});
